'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

/**
 * FocalPoint
 * The container that will maintain focus
 */

var React = require('react');
var stack = [];
var timer = null;

/**
 * To support server-side rendering, do not push the active element
 * when not in the browser environment
 */
if (typeof document !== 'undefined' && document.activeElement) {
  stack.push(document.activeElement);
}

var FocalPoint = React.createClass({
  displayName: 'FocalPoint',
  getDefaultProps: function getDefaultProps() {
    return {
      element: 'div'
    };
  },
  contains: function contains(element) {
    return this.refs.root.contains(element);
  },
  focus: function focus() {
    if (this.contains(document.activeElement) === false) {
      this.refs.root.focus();
    }
  },
  trapFocus: function trapFocus(e) {
    clearTimeout(timer);
    timer = setTimeout(function (_) {
      return stack[stack.length - 1].focus();
    }, 10);
  },
  returnFocus: function returnFocus() {
    var anchor = this.state.anchor;

    // When transitioning between pages using hash route state,
    // this anchor is some times lost. Do not attempt to focus
    // on a non-existent anchor.

    if (anchor && (typeof anchor === 'undefined' ? 'undefined' : _typeof(anchor)) === 'object' && typeof anchor.focus === 'function') {
      anchor.focus();
    }
  },
  componentWillMount: function componentWillMount() {
    if (typeof document !== 'undefined') {
      this.setState({ anchor: document.activeElement });
    }
  },
  componentDidMount: function componentDidMount() {
    stack.push(this);

    this.trapFocus();

    document.addEventListener('focus', this._onBlur, true);
  },
  componentWillUnmount: function componentWillUnmount() {
    var _this = this;

    stack = stack.filter(function (i) {
      return i !== _this;
    });

    document.removeEventListener('focus', this._onBlur, true);

    clearTimeout(timer);

    this.returnFocus();
  },
  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var Element = _props.element;
    var className = _props.className;


    return React.createElement(
      Element,
      { ref: 'root', tabIndex: '0', className: className },
      children
    );
  },
  _onBlur: function _onBlur(event) {
    var current = stack[stack.length - 1];

    if (current && current.contains(event.target) === false) {
      event.preventDefault();
      this.trapFocus();
    }
  }
});

module.exports = FocalPoint;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/react-focus-trap/src/focal-point.js
// module id = 5543
// module chunks = 0